import React, {useState, useEffect} from "react";
import {format} from "date-fns";
import {
    Card,
    CardContent,
    Grid,
    Typography,
    Box,
    Button,
    makeStyles,
    useMediaQuery,
    Dialog, CardMedia, IconButton
} from "@material-ui/core";
import moment from "moment";
import {ReactComponent as CalendarSVG} from "../../Images/calendar.svg";
import {ReactComponent as ClockSVG} from "../../Images/clock.svg";
import {ReactComponent as StethoscopeSVG} from "../../Images/stethoscope.svg";
import {ReactComponent as DocSVG} from "../../Images/vetDoctor.svg";
import {colorAdditional} from "../../Constants/theme";
import {
    servicesChat,
    setAppointmentPrice,
    setType,
    setAppointmentFee,
    setTypeForVet
} from "../../Constants/serviceType";
import {AnimalProfile} from "../../Components";
import Image from "material-ui-image";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";
import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {getPetByID, getPetsList, setSelectedAnimal} from "../../redux/pets/pets.actions";
import {setSelectedAppointment as setAppointmentToRedux} from "../../redux/appointment/appointment.actions";
import {setPetAge} from "../../utils/petInfo";
import {useLightbox} from "simple-react-lightbox";
import {setImage, updateShowVideo} from "../../redux/images/images.actions";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import VetProfile from "../Modals/VetProfile";
import Slide from "@material-ui/core/Slide";
import {TransitionProps} from "@material-ui/core/transitions";
import API from "../../helpers/apiHelpers";
import {jsPDF} from "jspdf";
import Logo from "../../Images/logoNew.png";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PetParentProfile from "../Modals/PetParentProfile";

const useStyle = makeStyles((theme) => ({
    buttons: {
        width: 184,
        marginBottom: 10,
        marginRight: 13
    },
    buttonNotes: {
        width: 184,
        padding: "12px 10px",
        marginBottom: 10
    },
    videoCard: {
        position: "relative",
        cursor: "pointer"
    },
    videoBtn: {
        color: "#000",
        width: "2em",
        height: "2em",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "2em"
    },
    videoBtnMob: {
        color: "#000",
        width: "2em",
        height: "2em",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "2em"
    }
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AppointmentCard = ({cardData = null, showNotes = null, handleChatData = null, over = false}) => {
    const [day, setDay] = useState("");
    const [time, setTime] = useState("");
    const [isOver, setIsOver] = useState(false);
    const [modalProfileVisibility, setModalProfileVisibility] = useState(false);
    const classes = useStyle();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const user = useSelector((state: RootState) => state?.user);
    const dispatch = useAppDispatch();
    const {openLightbox} = useLightbox();
    const [open, setOpen] = useState(false);
    const [clientOpen, setClientOpen] = useState(false);
    const [receipt, setReceipt] = useState<any>();
    const [logoB64, setLogoB64] = useState("");
    const [client, setClient] = useState(null);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const logo = useSelector((state: RootState) => state?.branding.logo);

    const {
        appointmentData, vetProfile = {
            lastName: "",
            baseChatOnlyFee: "",
            baseVirtualFee: "",
            image: "",
        }
    } = cardData;
    const {
        firstName,
        lastName,
        image
    } = vetProfile;
    const {
        id,
        type,
        description,
        scheduledDate,
        animal,
        imageUrl,
        videoUrl,
        pending,
        status,
        paidTotalAmount
    } = appointmentData;
    const {
        id: animalId,
        name,
        animalType,
        dateOfBirth,
    } = animal;

    const setDrName = () => {
        switch (type) {
            case "IMMEDIATE_CHAT":
                if (firstName) return firstName;
                return "Immediate Chat";
            case "IMMEDIATE_CALL":
                if (firstName) return firstName;
                return "Immediate Call";
            default:
                if (lastName) {
                    return `Dr. ${lastName}`;
                }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const convertBase64 = async (img) => {
        // blob to dataURL
        function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function (e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        }

        const file = await fetch(img).then(res => res.blob());

        blobToDataURL(file, function (dataurl) {
            setLogoB64(dataurl);
        });
    };

    useEffect(() => {
        if (scheduledDate) {
            const date = new Date(scheduledDate);
            const day = format(date, "iii, LLL dd");
            const time = format(date, "h:mmaaaa");
            setTime(time);
            setDay(day);
            setIsOver(moment(scheduledDate).isBefore(moment()));
        }
    }, [scheduledDate]);

    useEffect(() => {
        (async () => {
            if (!pending && status === "ACCEPTED") {
                const data = await API.getAppointmentReciept(appointmentData.id);
                if (!Object.prototype.hasOwnProperty.call(data, "message")) {
                    convertBase64(Logo);
                    setReceipt(data);
                }
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (appointmentData) {
                const data = await API.getProfiles({userId: appointmentData.clientUserId});
                setClient(data[0]);
            }
        })();
    }, []);

    const handleReceipt = () => {
        const bundleType = receipt.bundleUsedForCurrentAppointment ? receipt?.bundle.creditRequestType : "";
        const doc = new jsPDF();
        doc.addImage(logoB64, 10, 7, 20, 20, "logo", "NONE", 0);
        doc.setFontSize(12);
        doc.text("Contact Us", 100, 10, {align: "center"});
        doc.text("hello@thevideovets.com", 100, 17, {align: "center"});
        doc.text("1621 Central Ave.", 180, 10, {align: "center"});
        doc.text("Cheyenne, WY 82001", 180, 17, {align: "center"});
        doc.setFontSize(16);
        doc.text("Appointment Receipt", 10, 50);
        doc.setFontSize(12);
        doc.text("Appointment ID", 15, 60);
        doc.text("Client", 15, 67);
        doc.text("Pet", 110, 74);
        doc.text("Date", 110, 60);
        doc.text("Time", 110, 67);
        doc.text("Veterinarian", 15, 74);
        //change color:
        doc.setTextColor(138, 138, 138);
        doc.text(receipt.appointmentId.toString(), 50, 60);
        doc.text(`${receipt.clientFirstName} ${receipt.clientLastName}`, 50, 67);
        doc.text(receipt.vetName, 50, 74);
        doc.text(receipt.appointmentDate, 128, 60);
        doc.text(moment(receipt.appointmentTime).format("LT"), 128, 67);
        doc.text(receipt.petName, 128, 74, {maxWidth: 70});
        //HR
        doc.setTextColor(0);
        doc.line(10, 87, 200, 87);
        //Line Items:
        doc.setFontSize(16);
        doc.text("Description", 15, 97);
        doc.text("Amount", 128, 97);
        doc.setFontSize(12);
        doc.text("Appointment Fee", 15, 107);
        doc.setTextColor(138, 128, 138);
        doc.text(!receipt.bundleUsedForCurrentAppointment ? receipt.paidPrice : `USD ${setAppointmentFee(bundleType)}.00`, 128, 107);
        //Payment lines:
        doc.setTextColor(0);
        doc.text("Total", 110, 127);
        doc.text("Payment Method", 87.5, 137);
        (receipt.bundleUsedForCurrentAppointment && receipt.numberOfLeftAdviceBundles) &&
            doc.text("Number of Advice appointments remaining", 40, 147);
        (receipt.bundleUsedForCurrentAppointment && bundleType === "ADVICE" && !receipt.numberOfLeftAdviceBundles) &&
            doc.text("Number of Advice appointments remaining", 40, 147);
        (receipt.bundleUsedForCurrentAppointment && receipt.numberOfLeftRXBundles) &&
            doc.text("Number of Advice + Medication appointments remaining", 15, 157);
        (receipt.bundleUsedForCurrentAppointment && bundleType === "DEFAULT" && !receipt.numberOfLeftRXBundles) &&
            doc.text("Number of Advice + Medication appointments remaining", 15, 157);
        doc.setTextColor(138, 138, 138);
        doc.text(!receipt.bundleUsedForCurrentAppointment ? receipt.paidTotalAmount : `USD ${setAppointmentPrice(bundleType)}.00`, 128, 127);
        doc.text(receipt.subscriptionUsedForCurrentAppointment ?
            "Subscription" :
            receipt.bundleUsedForCurrentAppointment ?
                (bundleType === "ADVICE" ?
                    "1 advice appointment bundle" :
                    "1 Advice + Medication appointment bundle") :
                receipt.cardType ? `${receipt.cardType} ****${receipt.cardLastFourDigits}` : "Complementary", 128, 137);
        (receipt.bundleUsedForCurrentAppointment && receipt.numberOfLeftAdviceBundles) &&
            doc.text(receipt.numberOfLeftAdviceBundles?.toString(), 128, 147);
        (bundleType === "ADVICE" && !receipt.numberOfLeftAdviceBundles) &&
            doc.text("0", 128, 147);
        (receipt.bundleUsedForCurrentAppointment && receipt.numberOfLeftRXBundles) &&
            doc.text(receipt.numberOfLeftRXBundles?.toString(), 128, 157);
        (bundleType === "DEFAULT" && !receipt.numberOfLeftRXBundles) &&
            doc.text("0", 128, 157);
        //Footer
        doc.setFontSize(10);
        doc.text("Thank you for choosing The Video Vets!", 100, 175, {align: "center"});
        doc.save(`${name}_${appointmentData.id}.pdf`);
    };
    return (
        <Box marginBottom="17px">
            <Card variant="outlined">
                <CardContent>
                    <Grid container justify="flex-start">
                        <Grid container justify="flex-start" item xs={12} sm={3}>
                            {
                                image ?
                                    <Box width="80px" height="80px" marginBottom="20px">
                                        <Image alt="pet image" src={image} errorIcon={<DocSVG/>}
                                            imageStyle={{objectFit: "cover", width: "80px", height: "80px"}}
                                            style={{width: "80px", height: "80px"}}/>
                                    </Box>
                                    :
                                    <Box width="80px" height="80px" marginBottom="20px">
                                        <DocSVG width="80px" height="80px"/>
                                    </Box>
                            }
                        </Grid>
                        <Grid item xs={9} sm={8}>
                            <Box marginBottom="20px">
                                {user.role === "VET" ?
                                    client
                                    &&
                                    <Typography variant="h4">
                                        {`${client.firstName} ${client.lastName}`}
                                    </Typography>
                                    :
                                    <a style={{textDecoration: "none", cursor: "pointer"}} onClick={() => setOpen(true)}
                                        aria-label="view vet profile" href="#">
                                        <Typography variant="h4">
                                            {setDrName()}<OpenInNewIcon fontSize="small"/>
                                        </Typography>
                                    </a>
                                }
                            </Box>
                            <Grid container alignItems="center" wrap="wrap">
                                <Grid item container xs={12} alignItems="baseline" justify="flex-start">
                                    <Box marginRight="8px" marginBottom="15px">
                                        <CalendarSVG/>
                                    </Box>
                                    <Typography variant="h4">
                                        {day}
                                    </Typography>
                                </Grid>
                                <Grid item container xs={12} alignItems="baseline" justify="flex-start">
                                    <Box marginRight="8px" marginBottom="15px">
                                        <ClockSVG/>
                                    </Box>
                                    <Typography variant="h4">
                                        {time}
                                    </Typography>
                                </Grid>
                                <Grid item container xs={12} alignItems="baseline" justify="flex-start">
                                    <Box marginRight="8px" marginBottom="15px">
                                        <StethoscopeSVG/>
                                    </Box>
                                    <Typography variant="h4">
                                        {user.role === "OWNER" ? setType(type) : setTypeForVet(type)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {(type !== "RHAPSODY" && paidTotalAmount) &&
                        <Grid item xs={4} sm={2}>
                            <div>
                                <Typography variant="h4">
                                    ${paidTotalAmount?.replace("USD", "")}
                                </Typography>
                            </div>
                        </Grid>}
                    </Grid>
                    <Box marginTop="20px" marginBottom="24px" borderBottom={`1px solid ${colorAdditional}`}/>
                    <Grid container justify="space-between">
                        <Grid item container xs={12} sm={7}>
                            <Grid item container xs={12} alignItems="baseline" justify="flex-start">
                                <Box>
                                    <Typography dangerouslySetInnerHTML={{ __html: `<b>${name} -&nbsp;</b>${setPetAge(dateOfBirth)}`}}
                                        style={{whiteSpace: "pre-wrap", maxWidth: "200px", textOverflow: "ellipsis", overflow: "hidden"}}></Typography>
                                </Box>
                            </Grid>
                            <Button
                                type="button"
                                className={classes.buttons}
                                variant="outlined"
                                color="primary"
                                disableElevation
                                onClick={async () => {
                                    const pet = await dispatch(getPetByID(animalId));
                                    dispatch(setSelectedAnimal(pet));
                                    setModalProfileVisibility(true);
                                }}
                            >
                                Profile
                            </Button>
                        </Grid>
                        <Grid item container xs={12} sm={5} direction="column"
                            alignItems={isMobile ? "flex-start" : "flex-end"}>
                            <Button
                                type="button"
                                className={classes.buttonNotes}
                                variant="outlined"
                                color="primary"
                                disableElevation
                                onClick={() => {
                                    dispatch(setAppointmentToRedux(appointmentData));
                                    showNotes(user.role === "OWNER" ? id : animal?.id);
                                }}
                            >
                                {
                                    user.role === "OWNER" ?
                                        "Doctor's Notes" : "View Notes / History"
                                }
                            </Button>
                            {servicesChat.includes(type) && over &&
                            <Button
                                type="button"
                                className={classes.buttonNotes}
                                variant="outlined"
                                color="primary"
                                disableElevation
                                onClick={() => {
                                    handleChatData(true, {item: appointmentData, vetProfile}, true);
                                    dispatch(setAppointmentToRedux(appointmentData));
                                }}
                            >
                                Transcript
                            </Button>
                            }
                            {(user.role === "OWNER" && receipt) &&
                            <Button
                                type="button"
                                className={classes.buttonNotes}
                                variant="outlined"
                                color="primary"
                                disableElevation
                                onClick={handleReceipt}
                            >
                                Receipt
                            </Button>
                            }
                            {(user.role === "VET") &&
                                <Button
                                    type="button"
                                    className={classes.buttonNotes}
                                    variant="outlined"
                                    color="primary"
                                    disableElevation
                                    onClick={() => setClientOpen(true)}
                                >
                                    Pet Parent Profile
                                </Button>
                            }
                        </Grid>
                    </Grid>
                    <Box maxWidth="435px">
                        <Box marginBottom="8px">
                            <Typography variant="h4">Other details</Typography>
                        </Box>
                        <Typography style={{whiteSpace: "pre-line"}}>{description}</Typography>
                    </Box>
                    {(imageUrl || videoUrl) &&
                    <Box display="flex" flexWrap="wrap" marginBottom="20px" marginTop="20px">
                        {
                            imageUrl &&
                            imageUrl.map((url, idx) =>
                                <Box key={idx} width="27%" height="auto" marginRight="10px" marginBottom="10px">
                                    <Image
                                        alt="pet image"
                                        src={url} errorIcon={<LogoSVG/>}
                                        imageStyle={{objectFit: "cover", width: "100%", height: "100%"}}
                                        style={{cursor: "pointer"}}
                                        onClick={() => {
                                            dispatch(setImage(url));
                                            setTimeout(() => {
                                                openLightbox();
                                            }, 100);
                                        }}
                                    />
                                </Box>)
                        }
                        {
                            videoUrl &&
                            <Box width="27%" height="auto" marginRight="10px" marginBottom="10px" className={classes.videoCard}
                                onClick={() => {
                                    dispatch(setImage(videoUrl));
                                    dispatch(updateShowVideo(true));
                                }}
                            >
                                <CardMedia
                                    height="100%"
                                    src={isWhiteLabel ? logo : require("../../../src/Images/CircleLogo.png")}
                                    component={"img"}
                                />
                            </Box>
                        }
                    </Box>
                    }
                </CardContent>
            </Card>
            <AnimalProfile isOpen={modalProfileVisibility} animal={animal} setModalProfile={setModalProfileVisibility}/>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                scroll="body"
                disableEnforceFocus
            >
                <VetProfile profile={cardData.vetProfile} setOpen={setOpen}/>
            </Dialog>
            <Dialog
                open={clientOpen}
                keepMounted
                onClose={() => setClientOpen(false)}
                scroll="body"
                disableEnforceFocus
            >
                <PetParentProfile profile={client} setOpen={setClientOpen} isOpen={clientOpen}/>
            </Dialog>
        </Box>
    );
};


export default AppointmentCard;
